import * as imagesLoaded from 'imagesloaded'
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'
import common from './common'
import index from './index'
import concept from './concept'
import rooms from './rooms'
import partials from './partials'

gsap.registerPlugin(ScrollTrigger)

document.addEventListener('DOMContentLoaded', function() {
  partials().then(() => {
    imagesLoaded(document.getElementById('app'), () => {
      event()
      initContactForm()
      smoothScrollToTargetIfHashExists()
      require("fslightbox")
    })
  })
})

async function event() {
  const result = await initSmoothScroll(); 
  common(gsap, ScrollTrigger)
  index(gsap, ScrollTrigger)
  concept(gsap, ScrollTrigger)
  rooms(gsap, ScrollTrigger)
}

function initSmoothScroll(){
  return new Promise((resolve) => {
    const lenis = new Lenis({
      autoRaf: true,
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)
    resolve(true)
  })
}

function initContactForm() {
  setTimeout(()=>{
    const cf_selector = 'div.wpcf7 > form'
    const cf_forms = document.querySelectorAll(cf_selector)
    
    if (cf_forms.length > 0) {
      const cf_load = document.querySelector('.wpcf7-spinner')
      cf_load.remove()
      window.wpcf7.init(cf_forms[0])
    }
  },1000)
}


function smoothScrollToTargetIfHashExists() {
  const hash = window.location.hash;
  if (hash && hash !== "#") {
    const targetElement = document.getElementById(hash.split("#")[1]);
    if (targetElement) {
      scrollToAnimated(targetElement)
    }
  }
}

function scrollToAnimated(targetElement) {
  const scroll = new SmoothScroll()
  scroll.animateScroll(targetElement)
}


